/**
* @desc immutably updating state
* @param oldObject, updatedProperties
* @return updated object
*/
import moment from 'moment';

export const updateObject = (oldObject, updatedProperties) => {
    return {
        ...oldObject,
        ...updatedProperties
    };
};

/**
* @desc checks the validity for form
* @param value, rules
* @author Jamshith
* @return boolean
*/

export const checkValidity = ( value, rules ) => {
  let isValid = true;
  if ( !rules ) {
      return true;
  }

  if ( rules === 'required' ) {
      isValid = value.trim() !== '' && isValid;
  }

  if ( rules === 'minLength' ) {
      isValid = value.length >= rules.minLength && isValid
  }

  if ( rules === 'maxLength' ) {
      isValid = value.length <= rules.maxLength && isValid
  }

  if ( rules === 'isEmail' ) {
      const pattern =  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      isValid = pattern.test( value ) && isValid
  }

  if ( rules === 'isNumeric' ) {
      const pattern = /^\d+$/;
      isValid = pattern.test( value ) && isValid
  }

  if(rules === 'isFutureDate') {
    isValid = (moment(value)._d > moment(new Date())._d);
  }

  return isValid;
}

/**
* @desc compares with current time and returns the relative time
* @param timestamp
* @author Jamshith
* @return relative time 
*/

export const relativeTime = (timestamp)=> {
  const time = moment().diff(timestamp, 'minutes')>2880? moment(timestamp).format("DD/MM/YYYY")
    :(moment(timestamp).fromNow()==="a day ago") ? "1 day ago": moment(timestamp).fromNow();
    return time;
}


// WEBPACK FOOTER //
// ./src/shared/utility.js